import React from 'react';
import T from 'components/T';
import { DocumentList, UploadButton } from 'components/fields';
import { CandidateStoryDocument } from 'types/candidateStories';

type Props = {
  documents: CandidateStoryDocument[] | [];
  disabled: boolean;
  field: string;
  remove: (i: number) => void;
};

const CandidateStoryDocsForm = ({
  documents,
  disabled = false,
  field,
  remove,
}: Props) => {
  return (
    <div hidden={disabled} data-testid='candidate-story-docs-form-legacy'>
      <div className='cp-form-group'>
        <p>
          <T
            value='components.Report.CandidateStories.Modal.UploadDocuments.title'
            dangerousHTML
          />
        </p>

        <ul className='text-muted'>
          <T value='components.Report.examples' />
          <li>
            <T value='components.Report.CandidateStories.Modal.documents.example1' />
          </li>
          <li>
            <T value='components.Report.CandidateStories.Modal.documents.example2' />
          </li>
          <li>
            <T value='components.Report.CandidateStories.Modal.documents.example3' />
          </li>
        </ul>

        <UploadButton
          name={field}
          kind='secondary'
          context='candidate-stories'
        />
      </div>

      <div className='cp-form-group'>
        <DocumentList documents={documents} onRemove={remove} />
      </div>
    </div>
  );
};

export default CandidateStoryDocsForm;
